/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'None',
  'fabric.editor.headingLink.copied': 'None',
  'fabric.editor.headingLink.copyAnchorLink': 'None',
  'fabric.editor.headingLink.copyAriaLabel': 'None',
  'fabric.editor.headingLink.failedToCopy': 'None',
  'fabric.editor.inlineComment.marker.end': 'koniec vnoreného komentára',
  'fabric.editor.inlineComment.marker.start': 'začiatok vnoreného komentára',
};
